var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKey(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.917 13C12.441 15.8377 9.973 18 7 18C3.68629 18 1 15.3137 1 12C1 8.68629 3.68629 6 7 6C9.973 6 12.441 8.16229 12.917 11H23V13H21V17H19V13H17V17H15V13H12.917ZM7 16C9.20914 16 11 14.2091 11 12C11 9.79086 9.20914 8 7 8C4.79086 8 3 9.79086 3 12C3 14.2091 4.79086 16 7 16Z",
    fill: "url(#paint0_linear_448_30770)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 13H15V17H17V13Z",
    fill: "url(#paint1_linear_448_30770)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21 13H19V17H21V13Z",
    fill: "url(#paint2_linear_448_30770)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_448_30770",
    x1: 1,
    y1: 12,
    x2: 23,
    y2: 12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#026D4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#21B389"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_448_30770",
    x1: 15,
    y1: 15,
    x2: 17,
    y2: 15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8C745"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AF7B1D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_448_30770",
    x1: 19,
    y1: 15,
    x2: 21,
    y2: 15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8C745"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AF7B1D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKey);
export default __webpack_public_path__ + "static/media/key.c66682c892144f2eef2ff755b91b027b.svg";
export { ForwardRef as ReactComponent };